import { ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import {Location} from '@angular/common';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { Subject } from "rxjs";
import { finalize, takeUntil } from "rxjs/operators";
import endpoints from 'src/app/helpers/endpoints';

@Component({
  selector: 'fury-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class EditUserComponent implements OnInit, OnDestroy {
  ipAddressRegex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  userForm:FormGroup = new FormGroup({
    roleId: new FormControl(null, [Validators.required]),
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    emailAddress: new FormControl('', [Validators.required, Validators.pattern(/^[\w.-]+@[\w.-]+\.\w{2,3}$/),]),
    phoneNumber: new FormControl('', [Validators.required, Validators.pattern(/^[2-9][0-8]\d{1}[2-9]\d{2}\d{4}$/),]),
    password: new FormControl('', [Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$')]),
    attempts: new FormControl(0),
    startTime: new FormControl('', [Validators.required]),
    endTime: new FormControl('',[Validators.required]),
    editorAccess: new FormControl(false),
    onlineAccess: new FormControl(false),
    accessedIp: new FormArray([
      new FormControl(null, [Validators.required, Validators.pattern(this.ipAddressRegex)])
    ]),
    subRoleId: new FormControl(null),
    isActive: new FormControl(false),
    manualCreditScore: new FormControl(''),
    leadSources: new FormControl(null),
    isTerminated: new FormControl(false),
    excludeBadLead: new FormControl(false),
    excludeDuplicateLead: new FormControl(false),
    excludeRestrictedLead: new FormControl(false),
    excludeLeadStatuses: new FormControl(null),
    excludeStates: new FormControl(null),
    excludeFlagLead: new FormControl(false),
    bypassIpAddress: new FormControl(false),
    specialAccess: new FormControl(false),
  })
  
  scheduleFormControlItem: FormControl = new FormControl('');
  adminTypeList = [];
  hide:boolean = true;
  userId!:string;
  userData:any;
  ngUnsubscribe = new Subject<void>();
  subRoles = [];
  leadSources = [];
  isClaimRole: boolean = false;
  isPartnerRole: boolean = false;
  isOtherUser : boolean = false;
  isExternalUser : boolean = false;
  isSelectedPartner = false;
  isSelectedClaim = false;
  workingDaysSchedule = null;
  workingDaysData = {
    Sunday: [],
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
    Friday: [],
    Saturday: [],
  };

  stateList = [];
  excludeLeadStatusesOptions = ['Not Billable', 'Not Billable FL'];
  isLoading = false;
  constructor(
    public apiService: ApiService,
    public location: Location,
    private activateRoute: ActivatedRoute,
    private cdRef: ChangeDetectorRef
  ) { }


   ngOnInit(): void {
    this.userId = this.activateRoute.snapshot.params["id"];
    this.validatePassword(this.userId ? false : true);  
    this.activateRoute.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (res: any)=>{
        this.isClaimRole = res?.claimUser === 'true'
        this.isPartnerRole = res?.partnerUser === 'true'
        this.isExternalUser = res?.isExternalUser === 'true' || this.isPartnerRole;
        this.isOtherUser = ![this.isClaimRole,this.isPartnerRole].includes(true);
        this.getAdminType();
        this.getLeadSources();
        this.getStateList();
        if(this.isExternalUser){
          this.ipAddress.clear();
        } else {
          if(this.ipAddress.length === 0) this.addField();
        }
      }
    });
    if(!this.isExternalUser) this.bypassIpAddressValueChanges();
  }

  getStateList(){
    this.apiService.get('admin/state/get-all-states?page=1&size=99999').pipe(takeUntil(this.ngUnsubscribe)).subscribe((res:any)=>{
      if(res.body){
        this.stateList = res.body?.states?.data;
      }
    })
  };
  
    getLeadSources(){
      this.apiService.get(endpoints.user.getLeadSources).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res:any)=>{
        if(res.body){
          this.leadSources = res.body?.leadSources || [];
        }
      })
    }
 
  openFromIcon(timepicker: { open: () => void }) {
    timepicker.open();
  }
  onClear($event: Event) {
    this.scheduleFormControlItem.setValue(null);
  }
  getAdminType(){
    this.apiService.get(`admin/role/get-all-roles?page=1&size=9999&isParent=1&type=${this.isExternalUser ? 'external' : 'internal'}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res:any)=>{
      if(res.body){
        this.adminTypeList = res.body.roles.data;
        if(this.userId) this.getUserData();
        if(this.isClaimRole && !this.userId) {
          const roleId = this.adminTypeList.find(ele => ele.title?.toLowerCase() === "claims")?.roleId || null; 
          this.userForm.get("roleId").setValue(this.isExternalUser ? roleId : [String(roleId)]);
           this.userForm.get("roleId").updateValueAndValidity();
        }
        if(this.isPartnerRole && !this.userId) {
         const roleId = this.adminTypeList.find(ele => ele.title?.toLowerCase() === "partner")?.roleId || null; 
         this.userForm.get("roleId").setValue(this.isExternalUser ? roleId : [String(roleId)]);
         this.userForm.get("roleId").updateValueAndValidity();
        }
      }
    })
  };
  getUserData(){
    this.apiService.get(`admin/user/get-user/${this.userId}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res:HttpResponse<any>)=> {
      if(res.body){
        this.userData = res.body?.user;
        if(this.userData?.workingDays) this.workingDaysData = this.userData?.workingDays;
        this.userForm.patchValue(res?.body?.user);
        this.userForm.patchValue({
          startTime: res?.body?.user?.cutOffHours?.startTime.slice(0, 5),
          endTime: res?.body?.user?.cutOffHours?.endTime.slice(0, 5),
        });
        if(this.isExternalUser && this.userData?.newRole){
          // Need to change the binding newRoles & newSubRoles
          this.userForm.get("roleId").setValue(this.userData?.newRole[0]?.roleId);
        } else {
          // Need to change the binding newRoles & newSubRoles
          this.userForm.get("roleId").setValue(this.userData?.newRole?.map((item: any) => item?.roleId));
        }
        if(this.userData?.newSubRoles) this.userForm.get("subRoleId").setValue(this.userData?.newSubRoles?.map((item: any) => item?.roleId));
        if(this.userData?.accessedIp){
          this.ipAddress.clear();
          this.userData?.accessedIp?.forEach(element => {
           if(element){
            this.ipAddress.push(new FormControl(element, [Validators.required, Validators.pattern(
              this.ipAddressRegex
            ),]))
           }

          });
        }
        if(this.userData?.accessedIp?.length === 0 && !this.isExternalUser){
          this.addField(!this.userData?.bypassIpAddress);
        }
        if(this.userData?.subRoles?.length > 0){
          const subRoleId = this.userData?.subRoles.map((item: any)=> item?.id);
          this.userForm.get('subRoleId').setValue(subRoleId);
        }
      }
    }, (err: HttpErrorResponse)=> {
      this.apiService.alert(err.message, ErrorType.Error);
    })
  }
  addEditUser() {
    if(this.userForm.valid){
      const apiUrl = this.userId ? `admin/user/update-user/${this.userId}` : 'admin/user/create-user';
      let roleIds: any = this.userForm.get("roleId").value;
      if(this.isExternalUser){
        roleIds = [String(roleIds)];
      }
      const subRoleIds: any[] = this.userForm.get("subRoleId").value;
      const rolesAndSubRolePayload = this.createRoleAndSubRolePayload(roleIds, subRoleIds, this.adminTypeList);
      let payload : any = {
        firstName: this.userForm.value?.firstName,
        lastName: this.userForm.value?.lastName,
        emailAddress: this.userForm.value?.emailAddress,
        phoneNumber: this.userForm.value?.phoneNumber,
        password: this.userForm.value?.password,
        attempts: (this.isSelectedClaim && this.userForm.get('roleId').value?.length === 1) ? 0 : this.userForm.value?.attempts,
        editorAccess: this.userForm.value?.editorAccess,
        accessedIp: this.userForm.value?.accessedIp?.filter((ip) => ip !== null && ip !== undefined && ip !== ""),
        workingDays:  this.isSelectedClaim ? this.workingDaysSchedule : null,
        isActive:  this.isSelectedClaim ? this.userForm.value?.isTerminated ? false : this.userForm.value?.isActive : null,
        isTerminated: this.isSelectedClaim ? this.userForm.value?.isTerminated : null,
        assignedRole: rolesAndSubRolePayload,
        type: this.isExternalUser ? 'external' : 'internal',
        bypassIpAddress: this.userForm.value?.bypassIpAddress,
        specialAccess: this.userForm.value?.specialAccess,
      };
      payload.cutOffHours = {
        startTime: this.userForm.value?.startTime +':00',
        endTime: this.userForm.value?.endTime + ':00'
      }
      if((!this.userForm.value?.password && this.userId) || this.isSelectedPartner) {
        delete payload.password;
      }
      if(this.isSelectedClaim) payload.manualCreditScore = this.userForm.get('manualCreditScore').value || 0;
      if(this.isSelectedPartner) {
      payload = {...payload,  
        onlineAccess:  this.userForm.get('onlineAccess').value,
        leadSources:  this.userForm.get('leadSources').value,
        excludeBadLead:  this.userForm.get('excludeBadLead').value,
        excludeDuplicateLead:  this.userForm.get('excludeDuplicateLead').value,
        excludeRestrictedLead:  this.userForm.get('excludeRestrictedLead').value,
        excludeLeadStatuses : this.userForm.get('excludeLeadStatuses').value,
        excludeStates: this.userForm.get('excludeStates').value,
        excludeFlagLead: this.userForm.get('excludeFlagLead').value
      }
       }
       if(this.isExternalUser) delete payload.accessedIp;
       this.isLoading = true;
        this.apiService.post(apiUrl, payload).pipe(finalize(()=> this.isLoading = false), takeUntil(this.ngUnsubscribe)).subscribe((res: any)=>{
          if(res){
            this.apiService.alert(res?.body?.message, ErrorType.Success);
            this.location.back();
          }
        }, err =>{
          this.apiService.alert(err.message, ErrorType.Error);
        });
    } else {
      this.userForm.markAllAsTouched();
    }
  };

  restrictSpace(event: any) {
    if (event.target.value.match(/\s/g)) {
      event.target.value = event.target.value.replace(/\s/g, '');
    }
  }
  get ipAddress() {
    return this.userForm.get("accessedIp") as FormArray;
  }

  addField(isRequired = true) {
    let ipAddressValidation = isRequired ? [Validators.required, Validators.pattern(this.ipAddressRegex)] : [Validators.pattern(this.ipAddressRegex)];
    const newField = new FormControl("", ipAddressValidation);
    this.ipAddress.push(newField);
  }
  removeField(index: number) {
    this.ipAddress.removeAt(index);
  }
  onChangeRole(roleId: any){
    if(this.isExternalUser){
      roleId = [String(roleId)];
    }
    this.userForm.get('subRoleId').setValue([]);
    this.subRoles = this.getSubRoles(roleId);
    this.validateSubRole(this.subRoles.length > 0);
    this.isSelectedClaim = this.checkParticularRole(roleId, 'claim');
    this.validateAttempts((this.isSelectedClaim && roleId?.length === 1));
    this.isSelectedPartner = this.checkParticularRole(roleId, 'partner');
    this.validateLeadSources(this.isSelectedPartner);
    if(this.isSelectedPartner && this.isExternalUser){
      this.userForm.get('password').setValue('');
      this.validatePassword(false);
    } else {
      if(!this.userId) this.validatePassword(true);
    }
    this.cdRef.detectChanges();
  }
  onChangeSubRole(subRoleIds: any[]){
    this.checkSubRoleIds(this.userForm.get('roleId').value, subRoleIds);
  }
  checkSubRoleIds(roleIds: any[], selectedSubRoleIds: any[]) {
    const subRoleIDcontrol = this.userForm.controls.subRoleId;
    const rolesWithSubRoles = roleIds
      .map((roleId) =>
        this.adminTypeList.find((role) => role.roleId === roleId)
      )
      .filter((role) => role && role.subRoles && role.subRoles.length > 0);

    const valid = rolesWithSubRoles.every((role) =>
      role.subRoles.some((subRole) =>
        selectedSubRoleIds.includes(subRole.roleId)
      )
    );
    subRoleIDcontrol.setErrors(valid ? null : { invalid: true });
  }
  validateSubRole(isRequired: boolean){
    const subRoleIDcontrol = this.userForm.get('subRoleId');
    if(isRequired){
      subRoleIDcontrol.setValidators(Validators.required);
      subRoleIDcontrol.updateValueAndValidity();
    } else {
      subRoleIDcontrol.clearValidators();
      subRoleIDcontrol.updateValueAndValidity();
    }
  }

  validateAttempts(isOnlySelectedClaim: boolean){
    const attemptsControl = this.userForm.get('attempts');
    if(isOnlySelectedClaim){
      attemptsControl.clearValidators();
      attemptsControl.updateValueAndValidity();
    } else {
      attemptsControl.setValidators(Validators.required);
      attemptsControl.updateValueAndValidity();
    }
  }

  validateLeadSources(isRequired: boolean){
    const control = this.userForm.get('leadSources');
    if(isRequired){
      control.setValidators(Validators.required);
      control.updateValueAndValidity();
    } else {
      control.clearValidators();
      control.updateValueAndValidity();
    }
  }

  getTimeSchedulePayload(event: any){
    this.workingDaysSchedule = event;
  }
  validatePassword(isRequired: boolean) {
    const password = this.userForm.get('password');
    if(isRequired){
      password.setValidators([Validators.required, Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$')]);
      password.updateValueAndValidity();
    } else {
      password.setValidators([Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$')]);
      password.updateValueAndValidity();
    }
  }
  createRoleAndSubRolePayload(roleIds: any[], subRoleIds:any[], allRoleList:any[]) {
    const filteredRoles = allRoleList.filter(role => roleIds.includes(role?.roleId));
    const payload = filteredRoles.map(role => {
      const matchingSubRoles = role.subRoles
        .filter(subRole => subRoleIds?.includes(subRole?.roleId))
        .map(subRole => subRole?.roleId);
      
      return {
        roleId: role.roleId,
        subRoleId: matchingSubRoles
      };
    });
    return payload;
  }
  getSubRoles(roleIds: any[]){
    let mergedSubRoles = [];
    this.adminTypeList.forEach(role => {
      if (roleIds.includes(role.roleId) && role.subRoles.length > 0) {
        mergedSubRoles =  [...mergedSubRoles, ...role.subRoles]
      }
    });
    return mergedSubRoles;
  }
  checkParticularRole(roleIds: any[], roleName: string): boolean {
    const roleIdsSet = new Set(roleIds);
    return this.adminTypeList.some(role => {
      return roleIdsSet.has(role.roleId) && role?.title?.toLowerCase().includes(roleName.toLowerCase());
    });
}
bypassIpAddressValueChanges(){
  this.userForm
  .get("bypassIpAddress")
  ?.valueChanges.pipe(takeUntil(this.ngUnsubscribe))
  .subscribe((res) => {
   if(res){
    this.ipAddress.controls.forEach((control: FormControl) => {
      if(control.invalid){
        control.reset();
      }
      control.setValidators([Validators.pattern(this.ipAddressRegex)]);
      control.updateValueAndValidity();
    });
   } else {
    this.ipAddress.controls.forEach((control: FormControl) => {
     control.setValidators([Validators.required, Validators.pattern(this.ipAddressRegex)]);
     control.updateValueAndValidity();
    });
   }
  });

}

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
